export const translations = {
  es: {
    nav: {
      recovery: "Recuperación",
      services: "Servicios",
      howItWorks: "Cómo funciona",
      faq: "FAQ",
      contact: "Contacto",
      callNow: "Llámame",
      clientLogin: "Iniciar sesión",
      clientLoginShort: "Entrar",
      staffLogin: "Acceso equipo",
      staffLoginShort: "Equipo"
    },
    hero: {
      badge: "Transporte de vehículos profesional",
      title: "La forma más",
      titleHighlight: "rápida",
      titleEnd: "y confiable de mover tu vehículo",
      description: "Trabajamos con una red nacional de transportistas verificados. Soluciones rápidas, seguras y con tarifas asequibles.",
      verified: "Transportistas verificados",
      insured: "Seguro incluido",
      delivery: "Entrega a domicilio",
      formTitle: "Solicita tu presupuesto gratuito",
      pickupLocation: "Lugar de recogida",
      pickupPlaceholder: "Ciudad de origen",
      deliveryLocation: "Lugar de entrega",
      deliveryPlaceholder: "Ciudad de destino",
      pickupDate: "Fecha de recogida",
      deliveryDate: "Fecha de entrega",
      vehicleType: "Tipo de vehículo",
      vehiclePlaceholder: "Ej: Turismo, Moto, Furgoneta",
      name: "Nombre completo",
      namePlaceholder: "Tu nombre",
      email: "Email",
      emailPlaceholder: "tu@email.com",
      phone: "Teléfono",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Solicitar presupuesto",
      successTitle: "¡Solicitud enviada!",
      successDescription: "Nos pondremos en contacto contigo pronto con tu presupuesto personalizado.",
      errorTitle: "Error",
      errorDescription: "Hubo un problema al enviar tu solicitud. Por favor, inténtalo de nuevo."
    },
    stats: {
      vehicles: "+10,000",
      vehiclesLabel: "Vehículos transportados",
      satisfaction: "98%",
      satisfactionLabel: "Clientes satisfechos",
      delivery: "24-72h",
      deliveryLabel: "Entrega promedio"
    },
    howItWorks: {
      title: "¿Cómo funciona?",
      subtitle: "Tu entrega en tres pasos: 1, 2, ¡Go!",
      step1Title: "Solicita presupuesto",
      step1Description: "Rellena el formulario con los detalles de tu transporte y recibe un presupuesto personalizado en minutos.",
      step2Title: "Confirmamos y recogemos",
      step2Description: "Una vez aceptes el presupuesto, coordinamos la recogida de tu vehículo en la ubicación que prefieras.",
      step3Title: "Entregamos tu vehículo",
      step3Description: "Llevamos tu vehículo de forma segura a su destino. Seguimiento en tiempo real incluido."
    },
    services: {
      title: "Nuestros servicios",
      subtitle: "Soluciones completas de transporte",
      national: "Transporte Nacional",
      nationalDesc: "Traslado rápido y seguro de tu vehículo a cualquier punto de España. Cobertura completa en toda la península.",
      international: "Transporte Internacional",
      internationalDesc: "Llevamos tu vehículo a cualquier país de Europa con total garantía y seguimiento en tiempo real.",
      fleet: "Transporte de Flotas",
      fleetDesc: "Soluciones especializadas para empresas con múltiples vehículos. Gestión eficiente y precios competitivos."
    },
    recovery: {
      badge: "Servicio Especializado 24/7",
      leader: "Líderes en Europa",
      title: "Recuperación de Vehículos en toda Europa",
      description: "Líderes europeos en recuperación profesional de vehículos por impagos, alquiler no devuelto y situaciones complejas",
      service1Title: "Impagos y Embargos",
      service1Desc: "Recuperación legal de vehículos por impago de financiación o leasing. Gestión completa y discreta.",
      service2Title: "Alquiler No Devuelto",
      service2Desc: "Localización y recuperación de vehículos de alquiler no devueltos. Cobertura en toda Europa.",
      service3Title: "Recuperación en Toda Europa",
      service3Desc: "Operamos en cualquier país europeo. Red internacional de profesionales especializados.",
      btn1: "Solicitar Recuperación Urgente",
      btn2: "Consulta Rápida",
      whyTitle: "¿Por qué elegirnos?",
      reason1Title: "Respuesta Inmediata",
      reason1Desc: "Atención 24/7. Te respondemos en minutos y actuamos de inmediato.",
      reason2Title: "Cobertura Europea",
      reason2Desc: "Red de profesionales en toda Europa. Localizamos y recuperamos en cualquier país.",
      reason3Title: "100% Legal y Discreto",
      reason3Desc: "Procedimientos legales, documentación completa y máxima confidencialidad.",
      available: "Disponible 24/7",
      allEurope: "Toda Europa",
      legal: "100% Legal",
      confidential: "Confidencial"
    },
    additionalServices: {
      badge: "Servicios Complementarios",
      title: "Más que transporte",
      subtitle: "Ofrecemos servicios adicionales para que tu vehículo llegue en perfectas condiciones",
      itv: "ITV y Homologación",
      itvDesc: "Gestionamos la ITV de tu vehículo antes del transporte para evitar problemas legales.",
      cleaning: "Limpieza Integral",
      cleaningDesc: "Limpieza completa interior y exterior antes de la entrega. Tu vehículo como nuevo.",
      technical: "Pit Stop Técnico",
      technicalDesc: "Revisión técnica completa: niveles, presión neumáticos, luces y sistema de frenos.",
      representation: "Representaciones",
      representationDesc: "Representamos a financieras y concesionarios en operaciones de compraventa, entregas y gestiones comerciales con total profesionalidad.",
      question: "¿Necesitas algún servicio adicional? Consúltanos sin compromiso",
      btn: "Consultar Servicios"
    },
    faq: {
      badge: "¿Tienes dudas?",
      title: "Te ayudamos a resolverlas",
      subtitle: "Las respuestas que buscas, de forma clara y directa",
      openBtn: "Ver respuesta",
      closeBtn: "Cerrar",
      notFound: "¿No encuentras lo que buscas?",
      contactBtn: "Contáctanos por WhatsApp"
    },
    footer: {
      description: "Transporte de vehículos profesional en toda España y Europa. Rápido, seguro y confiable.",
      quickLinks: "Enlaces rápidos",
      contact: "Contacto",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery. Todos los derechos reservados.",
      privacyPolicy: "Política de Privacidad",
      cookiesPolicy: "Política de Cookies"
    },
    ui: {
      promoRecoveryBanner: "🏆 Líderes en Recuperación | 24/7 | Click aquí",
      callShort: "Llamar",
      changeLanguageAria: "Cambiar idioma",
      whatsappButtonAria: "Contactar por WhatsApp",
      whatsappTooltipTitle: "💬 ¡Chatea con nosotros!",
      whatsappTooltipSubtitle: "Respuesta inmediata",
      logoAlt: "AutoGo",
      dateToBeConfirmed: "A confirmar",
      vehicleTypeNotSpecified: "No especificado",
      whatsappGeneric:
        "Hola, me gustaría solicitar información sobre el transporte de vehículos",
      whatsappQuoteFull: `Hola! Solicito presupuesto para transporte de vehículo:

📍 Recogida: {{pickup}}
📍 Entrega: {{delivery}}
📅 Fecha recogida: {{pickupDate}}
📅 Fecha entrega: {{deliveryDate}}
🚗 Tipo de vehículo: {{vehicleType}}

👤 Nombre: {{name}}
📧 Email: {{email}}
📱 Teléfono: {{phone}}

Espero su respuesta. Gracias!`
    },
    landingFaqItems: [
      {
        id: 1,
        question: "¿Cómo calculáis el precio del transporte?",
        answer:
          "Nuestro sistema calcula el precio basándose en múltiples factores: distancia exacta entre origen y destino, tipo de vehículo (dimensiones y peso), modalidad de transporte (en plataforma o conducido), urgencia del servicio y disponibilidad de transportistas en la ruta. Recibirás un presupuesto detallado y transparente sin costes ocultos."
      },
      {
        id: 2,
        question: "¿Qué garantías ofrecéis durante el transporte?",
        answer:
          "Todos nuestros traslados incluyen seguro a todo riesgo que cubre cualquier daño durante el transporte. Realizamos una inspección fotográfica completa antes de la recogida y después de la entrega. Trabajamos exclusivamente con transportistas verificados y con más de 5 años de experiencia. Además, ofrecemos seguimiento GPS en tiempo real."
      },
      {
        id: 3,
        question: "¿Qué cobertura incluye el seguro?",
        answer:
          "Todos nuestros transportes incluyen un seguro a todo riesgo que cubre cualquier daño que pueda sufrir tu vehículo durante el traslado. La cobertura incluye daños por accidente, robo, vandalismo y fenómenos meteorológicos. Realizamos una inspección fotográfica completa antes de la recogida y después de la entrega para documentar el estado del vehículo."
      },
      {
        id: 4,
        question: "¿Ofrecéis recogida y entrega a domicilio?",
        answer:
          "Absolutamente. Recogemos tu vehículo en la dirección que nos indiques y lo entregamos donde necesites. No necesitas desplazarte a ningún depósito. Coordinamos horarios flexibles para adaptarnos a tu disponibilidad, tanto para la recogida como para la entrega."
      },
      {
        id: 5,
        question: "¿Trabajáis con empresas y concesionarios?",
        answer:
          "Sí, ofrecemos soluciones especializadas para empresas, concesionarios y gestoras de flotas. Incluyen: gestión de múltiples vehículos, precios corporativos, facturación mensual, coordinación logística personalizada y un gestor dedicado para tu cuenta. Contacta con nosotros para conocer nuestras tarifas empresariales."
      },
      {
        id: 6,
        question: "¿Cómo puedo hacer seguimiento de mi vehículo?",
        answer:
          "Una vez iniciado el transporte, recibirás un enlace de seguimiento GPS en tiempo real por email y SMS. Podrás ver la ubicación exacta de tu vehículo en cualquier momento. También te mantendremos informado de cada etapa: confirmación de recogida, inicio del trayecto y confirmación de entrega con fotos."
      }
    ]
  },
  en: {
    nav: {
      recovery: "Recovery",
      services: "Services",
      howItWorks: "How it works",
      faq: "FAQ",
      contact: "Contact",
      callNow: "Call me",
      clientLogin: "Login",
      clientLoginShort: "Login",
      staffLogin: "Staff login",
      staffLoginShort: "Staff"
    },
    hero: {
      badge: "Professional vehicle transport",
      title: "The",
      titleHighlight: "fastest",
      titleEnd: "and most reliable way to move your vehicle",
      description: "We work with a nationwide network of verified carriers. Fast, secure solutions with affordable rates.",
      verified: "Verified carriers",
      insured: "Insurance included",
      delivery: "Door-to-door delivery",
      formTitle: "Request your free quote",
      pickupLocation: "Pickup location",
      pickupPlaceholder: "Origin city",
      deliveryLocation: "Delivery location",
      deliveryPlaceholder: "Destination city",
      pickupDate: "Pickup date",
      deliveryDate: "Delivery date",
      vehicleType: "Vehicle type",
      vehiclePlaceholder: "E.g: Car, Motorcycle, Van",
      name: "Full name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "you@email.com",
      phone: "Phone",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Request quote",
      successTitle: "Request sent!",
      successDescription: "We will contact you soon with your personalized quote.",
      errorTitle: "Error",
      errorDescription: "There was a problem sending your request. Please try again."
    },
    stats: {
      vehicles: "+10,000",
      vehiclesLabel: "Vehicles transported",
      satisfaction: "98%",
      satisfactionLabel: "Satisfied customers",
      delivery: "24-72h",
      deliveryLabel: "Average delivery"
    },
    howItWorks: {
      title: "How it works?",
      subtitle: "Your delivery in three steps: 1, 2, Go!",
      step1Title: "Request quote",
      step1Description: "Fill out the form with your transport details and receive a personalized quote in minutes.",
      step2Title: "We confirm and collect",
      step2Description: "Once you accept the quote, we coordinate the pickup of your vehicle at your preferred location.",
      step3Title: "We deliver your vehicle",
      step3Description: "We safely transport your vehicle to its destination. Real-time tracking included."
    },
    services: {
      title: "Our services",
      subtitle: "Complete transport solutions",
      national: "National Transport",
      nationalDesc: "Fast and secure transport of your vehicle anywhere in Spain. Complete coverage throughout the peninsula.",
      international: "International Transport",
      internationalDesc: "We transport your vehicle to any European country with full guarantee and real-time tracking.",
      fleet: "Fleet Transport",
      fleetDesc: "Specialized solutions for companies with multiple vehicles. Efficient management and competitive prices."
    },
    recovery: {
      badge: "24/7 Specialized Service",
      leader: "Leaders in Europe",
      title: "Vehicle Recovery throughout Europe",
      description: "European leaders in professional vehicle recovery for non-payment, unreturned rentals and complex situations",
      service1Title: "Non-payment and Seizures",
      service1Desc: "Legal recovery of vehicles for financing or leasing non-payment. Complete and discreet management.",
      service2Title: "Unreturned Rental",
      service2Desc: "Location and recovery of unreturned rental vehicles. Coverage throughout Europe.",
      service3Title: "Recovery Throughout Europe",
      service3Desc: "We operate in any European country. International network of specialized professionals.",
      btn1: "Request Urgent Recovery",
      btn2: "Quick Consultation",
      whyTitle: "Why choose us?",
      reason1Title: "Immediate Response",
      reason1Desc: "24/7 service. We respond in minutes and act immediately.",
      reason2Title: "European Coverage",
      reason2Desc: "Network of professionals throughout Europe. We locate and recover in any country.",
      reason3Title: "100% Legal and Discreet",
      reason3Desc: "Legal procedures, complete documentation and maximum confidentiality.",
      available: "Available 24/7",
      allEurope: "All Europe",
      legal: "100% Legal",
      confidential: "Confidential"
    },
    additionalServices: {
      badge: "Additional Services",
      title: "More than transport",
      subtitle: "We offer additional services so your vehicle arrives in perfect condition",
      itv: "ITV and Homologation",
      itvDesc: "We manage your vehicle's ITV before transport to avoid legal problems.",
      cleaning: "Complete Cleaning",
      cleaningDesc: "Complete interior and exterior cleaning before delivery. Your vehicle like new.",
      technical: "Technical Pit Stop",
      technicalDesc: "Complete technical inspection: levels, tire pressure, lights and brake system.",
      representation: "Representations",
      representationDesc: "We represent financial institutions and dealers in sales operations, deliveries and commercial procedures with total professionalism.",
      question: "Need any additional service? Consult us without obligation",
      btn: "Consult Services"
    },
    faq: {
      badge: "Have questions?",
      title: "We help you solve them",
      subtitle: "The answers you seek, clearly and directly",
      openBtn: "View answer",
      closeBtn: "Close",
      notFound: "Can't find what you're looking for?",
      contactBtn: "Contact us on WhatsApp"
    },
    footer: {
      description: "Professional vehicle transport throughout Spain and Europe. Fast, safe and reliable.",
      quickLinks: "Quick links",
      contact: "Contact",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery. All rights reserved.",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy"
    },
    ui: {
      promoRecoveryBanner: "🏆 Vehicle Recovery Leaders | 24/7 | Click here",
      callShort: "Call",
      changeLanguageAria: "Change language",
      whatsappButtonAria: "Contact us on WhatsApp",
      whatsappTooltipTitle: "💬 Chat with us!",
      whatsappTooltipSubtitle: "Immediate response",
      logoAlt: "AutoGo",
      dateToBeConfirmed: "To be confirmed",
      vehicleTypeNotSpecified: "Not specified",
      whatsappGeneric:
        "Hello, I would like to request information about vehicle transport",
      whatsappQuoteFull: `Hello! I request a quote for vehicle transport:

📍 Pickup: {{pickup}}
📍 Delivery: {{delivery}}
📅 Pickup date: {{pickupDate}}
📅 Delivery date: {{deliveryDate}}
🚗 Vehicle type: {{vehicleType}}

👤 Name: {{name}}
📧 Email: {{email}}
📱 Phone: {{phone}}

Looking forward to your response. Thanks!`
    },
    landingFaqItems: [
      {
        id: 1,
        question: "How do you calculate the transport price?",
        answer:
          "Our system calculates the price based on multiple factors: exact distance between origin and destination, vehicle type (dimensions and weight), transport modality (on platform or driven), service urgency and carrier availability on the route. You will receive a detailed and transparent quote with no hidden costs."
      },
      {
        id: 2,
        question: "What guarantees do you offer during transport?",
        answer:
          "All our transfers include comprehensive insurance that covers any damage during transport. We perform a complete photographic inspection before pickup and after delivery. We work exclusively with verified carriers with more than 5 years of experience. Additionally, we offer real-time GPS tracking."
      },
      {
        id: 3,
        question: "What does the insurance cover?",
        answer:
          "All our transports include comprehensive insurance that covers any damage your vehicle may suffer during the transfer. Coverage includes damage from accidents, theft, vandalism and weather phenomena. We perform a complete photographic inspection before pickup and after delivery to document the vehicle's condition."
      },
      {
        id: 4,
        question: "Do you offer door-to-door pickup and delivery?",
        answer:
          "Absolutely. We pick up your vehicle at the address you indicate and deliver it wherever you need. You don't need to travel to any depot. We coordinate flexible schedules to adapt to your availability, both for pickup and delivery."
      },
      {
        id: 5,
        question: "Do you work with companies and dealerships?",
        answer:
          "Yes, we offer specialized solutions for companies, dealerships and fleet managers. They include: management of multiple vehicles, corporate prices, monthly billing, personalized logistics coordination and a dedicated manager for your account. Contact us to learn about our business rates."
      },
      {
        id: 6,
        question: "How can I track my vehicle?",
        answer:
          "Once the transport has started, you will receive a real-time GPS tracking link by email and SMS. You can see the exact location of your vehicle at any time. We will also keep you informed of each stage: pickup confirmation, journey start and delivery confirmation with photos."
      }
    ]
  }
};
